<template>
  <div>
    <div v-if="loader" style="display: flex; flex-direction: column; align-items: center; width: 100%; height: 500px; justify-content: center">
      <Loader></Loader>
    </div>
    <div v-if="!loader" id="print">
      <v-app>
        <link rel="stylesheet" type="text/css" href="/assets/css/templatecss.css" />
        <link rel="stylesheet" type="text/css" href="/assets/css/vuetify.css" />
        <v-content style="background-color: white">
          <div ref="content1" id="content_1" class="pageA4" v-if="projeto.cliente">
            <div class="container" style="padding-left: 50px; padding-bottom: 0px">
              <div class="text-center">
                <figure style="margin-top: 120px">
                  <img :src="projeto.contatoRevenda.imagemBase64" v-if="projeto.contatoRevenda.imagemBase64" style="height: 200px; margin-top: 2mm" />
                  <img :src="projeto.imagemUrl" v-if="projeto.imagemUrl" style="height: 200px; margin-top: 2mm" />
                </figure>
              </div>

              <div class="absolute" style="top: 120mm; right: 10mm">
                <h1 class="bold">Proposta Comercial</h1>
              </div>

              <div class="absolute" style="top: 135mm; right: 10mm">
                <h3>Gerador Fotovoltaico</h3>
              </div>

              <h3 class="absolute right" style="top: 162mm; right: 10mm">{{ descricaoSimplificada }}</h3>

              <h3 class="absolute right" style="top: 185mm; right: 10mm">{{ projeto.cliente.nome }}</h3>
              <h3 class="absolute right" style="top: 195mm; right: 10mm">{{ projeto.cliente.cidade }}-{{ projeto.cliente.estado }}</h3>
              <h4 class="absolute right" style="top: 210mm; right: 10mm">{{ projeto.cliente.endereco }}</h4>
              <h4 class="absolute right" style="top: 216mm; right: 10mm">{{ projeto.cliente.telefone1 }}</h4>
              <h4 class="absolute right" style="top: 222mm; right: 10mm">{{ projeto.cliente.email }}</h4>
              <h3 class="absolute right" style="top: 235mm; right: 10mm">Proposta nº {{ projeto.codigo }}</h3>
              <h4 class="absolute right" style="top: 246mm; right: 10mm">Validade: {{ projeto.validade }}</h4>
            </div>
          </div>

          <div ref="content2" id="content_2" class="pagebreak pageA4">
            <div class="img-header">
              <img :src="header" alt="" />
            </div>

            <div class="container">
              <h2 class="bold" style="margin-top: 30px">Descrição de Funcionamento</h2>
            </div>

            <div class="img-rede">
              <img :src="rede" alt="" />
            </div>

            <div class="container" style="margin-top: 20px; font-size: 16px">
              <p><strong>Como Funciona a Energia Solar?</strong></p>

              <p><strong>A energia solar fotovoltaica é a eletricidade gerada a partir da luz do sol.</strong></p>
              <br />

              <p><strong>1. Os painéis solares:</strong> Captam a luz do sol e a transformam em eletricidade.</p>

              <p>
                <strong>2. O inversor:</strong> A energia gerada pelos painéis solares passa por esse equipamento que prepara a energia para ser
                utilizada em nossos lares e empresas.
              </p>

              <p>
                <strong>3. Quando sobrar energia:</strong> O gerador é dimensionado para gerar mais energia do que consome durante o dia, deste modo
                essa energia extra gerada vai para a rede elétrica ou para baterias. Quando essa energia excedente vai para a rede elétrica passa pelo
                medidor de energia que gera créditos para você.
              </p>

              <p>
                <strong>4. Quando Usar os crédito:</strong> Durante à noite quando não há geração de energia você faz uso desse crédito gerado,
                pegando de volta o que foi injetado na rede elétrica. Em dias nublados ou com pouca luminosidade do sol, aonde a geração de energia
                não é suficiente para suprir o que está consumindo, você também faz uso dos seus créditos.
              </p>
            </div>
          </div>

          <div ref="content2" id="content_2" class="pagebreak pageA4" v-if="projeto.contatoRevenda && projeto.contatoRevenda.empresa">
            <div class="img-header">
              <img :src="header" alt="" />
            </div>

            <div class="img-footer text-center">
              <img :src="footer" alt="" />
            </div>

            <div class="container">
              <h2 class="bold" style="margin-top: 30px">O Seu Projeto</h2>
            </div>

            <div class="container">
              <div class="row" style="margin-top: 20px">
                <div class="infos-painel">
                  <info-box title="Consumo mensal" :value="toMoeda(consumoTotal) + ' kWh'"> </info-box>

                  <div>
                    <info-box title="Área mínima requirida" :value="toMoeda(parseFloat(caracteristicasBasicas.area)) + ' m²'"> </info-box>

                    <info-box title="Peso" :value="toMoeda(caracteristicasBasicas.weight) + ' kg'"> </info-box>
                  </div>

                  <div>
                    <info-box title="Produção Mensal" :value="toMoeda(producaoMensal) + ' kWh'"> </info-box>

                    <info-box title="Potência" :value="toMoeda(potenciaGerador) + ' kWp'"> </info-box>
                  </div>
                </div>
              </div>

              <hr />

              <h2 class="bold" style="margin-top: 30px">Investimento - Opções de pagamento</h2>
              <div class="row mt-3" style="margin-top: 30px">
                <div class="col-lg-6 col-sm-6 col-sm-6 col-xs-6">
                  <p class="label-t4">1 - À vista</p>
                </div>

                <div class="col-lg-6 col-sm-6 col-sm-6 col-xs-6">
                  <p class="label-t4">
                    {{ investimentoTotal | reais }}
                  </p>
                </div>
              </div>

              <div class="row" v-if="projeto.cliente.parcelasFinanciamento.length > 0">
                <hr style="border: 1px dashed #eee" />
                <div style="padding-left: 15px; padding-right: 15px">
                  <p class="label-t4">
                    2 - Financiamento Sol Agora
                    <img :src="solAgoraLogo" style="width: 35px" />
                  </p>
                </div>

                <div class="container-parcelas">
                  <div v-for="parcelaFinanciamento in projeto.cliente.parcelasFinanciamento">
                    <span class="text-best" v-if="parcelaFinanciamento.best == 1">Melhor opção</span>
                    <div class="parcela-valor" :class="{ best: parcelaFinanciamento.best == 1 }">
                      <span class="best">
                        {{ parcelaFinanciamento.parcela }} x de <br />
                        <strong>{{ parcelaFinanciamento.valor | reais }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="projeto.cliente.parcelasFinanciamento.length > 0" style="margin-top: 8px">Sujeito à aprovação de crédito.</div>

              <div class="row mt-3" v-if="projeto.cliente.parcelasCartao.length > 0">
                <hr style="border: 1px dashed #eee" />
                <div style="padding-left: 15px; padding-right: 15px">
                  <p class="label-t4">
                    {{ projeto.cliente.parcelasFinanciamento.length > 0 ? 3 : 2 }} - Cartão de crédito
                    <img :src="mastercardLogo" style="width: 35px" />
                    <img :src="visaLogo" style="width: 35px" />
                  </p>
                </div>

                <div class="container-parcelas">
                  <div class="parcela-valor" v-for="parcelaCartao in projeto.cliente.parcelasCartao">
                    <span>
                      {{ parcelaCartao.parcela }} x de <br />
                      <strong>{{ parcelaCartao.valor | reais }}</strong>
                    </span>
                  </div>
                </div>
              </div>

              <hr />
              <div style="margin-top: 8px; margin-bottom: 8px">Outras opções de pagamento sob consulta.</div>

              <h2 class="bold" style="margin-top: 30px">Benefícios</h2>

              <div class="row infos-painel" style="margin-top: 20px; max-width: 200mm; gap: 40px">
                <info-box title="Custo mensal atual" :value="'R$ ' + toMoeda(contaTotal)"></info-box>

                <info-box title="Investimento necessário" :value="'R$ ' + toMoeda(investimentoTotal)"></info-box>

                <info-box title="Economia em 25 anos" :value="'R$ ' + toMoeda(economia25Anos)"></info-box>
              </div>
            </div>
          </div>

          <div ref="content3" id="content_3" class="pagebreak pageA4" v-if="selectedProduct">
            <div class="img-header">
              <img :src="header" alt="" />
            </div>

            <div class="container">
              <h2 class="bold" style="margin-top: 30px">Equipamentos</h2>
            </div>

            <div class="container">
              <div class="row" style="display: flex; margin-top: 25px">
                <div class="col-xs-3" style="display: flex">
                  <div style="position: relative; padding: 10px; margin-right: 15px">
                    <img style="position: relative; top: 50%; transform: translateY(-50%)" :src="getImagemProduto" />
                  </div>
                </div>
                <div class="col-xs-9" v-if="selectedProduct" style="font-size: 16px">
                  <p class="px-0 font-italic">Código: {{ selectedProduct.PRD_CODIGO }}-{{ selectedProduct.PRD_CODIGODV }}</p>
                  <p class="pt-3">{{ selectedProduct.Titulo }}</p>
                </div>
              </div>
            </div>

            <div class="container" style="margin-top: 15px">
              <h2 class="bold" style="margin-top: 12px">Composição</h2>

              <div style="height: 520px">
                <table class="table" style="border-collapse: collapse; margin-top: 20px">
                  <thead style="color: #0083ca !important">
                    <tr style="font-size: 16px">
                      <th style="border-bottom: 0px; width: 3cm; padding: 2mm; text-align: right">Código</th>
                      <th style="border-bottom: 0px; padding: 2mm">Descrição</th>
                      <th style="border-bottom: 0px; width: 2cm; padding: 2mm; text-align: right">Un.</th>
                      <th style="border-bottom: 0px; width: 2cm; padding: 2mm; text-align: right">Qtd</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, i) in components"
                      v-bind:key="item.index"
                      :class="{ gray: i % 2 != 0 }"
                      style="height: 55px; border-collapse: collapse"
                    >
                      <td style="vertical-align: top; text-align: right; border-top: 0px; padding: 2mm">
                        {{ item.prdCodigo }}
                      </td>
                      <td style="vertical-align: top; border-top: 0px; padding: 2mm">
                        {{ item.descricao }}
                      </td>
                      <td style="vertical-align: top; text-align: right; border-top: 0px; padding: 2mm">
                        {{ item.unidade }}
                      </td>
                      <td style="vertical-align: top; text-align: right; border-top: 0px; padding: 2mm">
                        {{ item.quantidade }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="text-center">
              <img :src="garantia" style="width: 790px; height: 250px" />
            </div>
          </div>

          <!-- GRAFICO DE INVESTIMENTO -->
          <!-- <div ref="content_5" id="content_5" class="pagebreak pageA4">
            <div class="img-header">
              <img :src="header" alt="" />
            </div>
            <div class="container">
              <h2 class="bold" style="margin-top: 30px">Seu Retorno</h2>
            </div>
            <div class="graphic">
              <ROIChartBar :style="barStyles" :initial-investment="50000" :annual-return="1500" />
            </div>
            <div class="container">
              <h2 class="bold" style="margin-top: 30px">Sua Rentabilidade</h2>
            </div>
            <div class="graphic rentability">
              <div class="chart">
                <InvestmentComparison
                  :style="horizontalBarStyles"
                  :investment-label="['Poupança', 'CDI', 'Energia Solar']"
                  :investment-value="[6.7, 12.0, 24.5]"
                />
              </div>
            </div>
            <div class="information-data">
              <div class="information-data-content">
                <div>
                  <div class="information-data-image">
                    <img :src="arvore" alt="Árvores Salvas" />
                  </div>
                  <div class="information-data-text">1.062,54 Árvores Salvas</div>
                </div>
                <div>
                  <div class="information-data-image">
                    <img :src="carro" alt="Anos de um carro fora de circulação" />
                  </div>
                  <div class="information-data-text">68,90 Anos de um carro fora de circulação</div>
                </div>
                <div>
                  <div class="information-data-image">
                    <img :src="co2" alt="Toneladas de CO2 não emitidos" />
                  </div>
                  <div class="information-data-text">148,82 Toneladas de CO<sub>2</sub> não emitidos</div>
                </div>
              </div>
              <div class="information-data-footer">
                <p>
                  Baseado na Calculadora de Emissão de CO<sub>2</sub> do Programa de Gestão Ambiental Sustentável do Poder Judiciário do Estado do
                  Paraná
                </p>
              </div>
            </div>
          </div> -->

          <div ref="content_4" id="content_4" class="pagebreak pageA4">
            <div class="img-header">
              <img :src="header" alt="" />
            </div>

            <div class="container">
              <h2 class="bold" style="margin-top: 30px">Informações Adicionais</h2>
            </div>

            <div class="container">
              <div style="margin-top: 25px">
                <span class="label-t2 bold">Prazo de entrega (em dias úteis a partir do aceite da proposta)</span><br />
                <span>{{ projeto.prazoEntrega }} dias</span>
              </div>

              <div style="margin-top: 25px">
                <span class="label-t2 bold">Proposta válida até</span><br />
                <span>{{ projeto.validade }}</span>
              </div>

              <div v-if="projeto.observacoes.trim()" style="margin-top: 25px">
                <span class="label-t2 bold">Observações da proposta</span><br />
                <span>{{ projeto.observacoes }}</span>
              </div>

              <div style="margin-top: 180px">
                <span class="label-t2 bold">Para dúvidas ou outas informações</span><br />
                <span>{{ projeto.contatoRevenda.nome }}</span
                ><br />
                <div v-if="projeto.contatoRevenda.telefone.trim()">
                  <span>{{ projeto.contatoRevenda.telefone }}</span
                  ><br />
                </div>
                <div v-if="projeto.contatoRevenda.email.trim()">
                  <span>{{ projeto.contatoRevenda.email }}</span
                  ><br />
                </div>
              </div>

              <hr />

              <div class="text-center label-t2 bold">Aceite da proposta</div>
              <div class="signatures">
                <div class="text-center">
                  <div class="signature-border"></div>
                  <span class="label-t2 bold">{{ projeto.contatoRevenda.nome.toUpperCase() }}</span>
                </div>

                <div class="text-center">
                  <div class="signature-border"></div>
                  <span class="label-t2 bold">{{ projeto.cliente.nome.toUpperCase() }}</span>
                </div>
              </div>

              <div class="text-center" style="margin-top: 50px">
                <figure style="margin-bottom: 25px">
                  <img :src="projeto.contatoRevenda.imagemBase64" v-if="projeto.contatoRevenda.imagemBase64" style="height: 128px; margin-top: 2mm" />
                  <img :src="projeto.imagemUrl" v-if="projeto.imagemUrl" style="height: 128px; margin-top: 2mm" />
                </figure>
                <span>{{ projeto.contatoRevenda.empresa }}</span
                ><br />
                <span>{{ projeto.contatoRevenda.endereco }}</span
                ><br />
                <span>{{ projeto.contatoRevenda.email }}</span
                ><br />
                <span>{{ projeto.contatoRevenda.site }}</span
                ><br />
              </div>
            </div>
          </div>
        </v-content>
      </v-app>
    </div>
  </div>
</template>

<style>
.img-rede {
  max-width: 600px;
  margin: 20px auto;
  margin-top: 60px;
}

.img-header {
  max-width: 800px;
  margin: 0px auto;
}

.img-header img,
.img-footer img {
  width: 100%;
}

.img-footer {
  display: none;
}

.infos-painel {
  display: flex;
  gap: 50px;
  max-width: 160mm;
  margin: 0 auto;
  align-items: center;
}

@media print {
  .img-footer {
    max-width: 800px;
    bottom: 0;
    left: 0;
    right: 0;
    position: fixed;
    display: block;
  }

  #contant_1 .img-footer {
    display: none;
  }
}

.absolute {
  position: absolute;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.fs-16 {
  font-size: 16px;
}

.gray {
  background-color: #f9f9f9 !important;
}

@media print {
  @page {
    margin: 0;
  }

  html {
    margin: 0;
  }

  body {
    margin: 0;
    -webkit-print-color-adjust: exact;
  }
}

.container-parcelas {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  gap: 10px;
}

.parcela-valor {
  padding: 8px;
  border: 1px solid rgb(239, 239, 239);
  border-radius: 4px;
  text-align: center;
}

.parcela-valor.best {
  border: 2px solid #0083ca;
  color: #0083ca !important;
}

.text-best {
  position: absolute;
  margin-top: -15px;
  margin-left: 20px;
  text-align: center;
  font-size: 11px;
  color: #0083ca !important;
  font-weight: 600;
}

.signatures {
  display: flex;
  justify-content: space-between;
  max-width: 150mm;
  margin: 0 auto;
  margin-top: 100px;
}

.signature-border {
  width: 250px;
  border-bottom: 1px solid #747474;
}
</style>

<script>
import '../../../components/partials/santander/SantanderFilter.js'
// import ROIChartBar from '../../../Pages/Dashboard/Components/ROIChartBar.vue'
// import InvestmentComparison from '../../../Pages/Dashboard/Components/InvestmentComparison.vue'
import InfoBox from './InfoBox.vue'
import { mapActions, mapGetters } from 'vuex'
import Loader from './../../../components/partials/Loader.vue'

export default {
  name: 'TemplatePdfProjectNewV1',
  components: {
    InfoBox,
    // ROIChartBar,
    // InvestmentComparison,
    Loader,
  },
  beforeMount() {
    const url = new URL(location.href)
    const id = url.searchParams.get('proj')
    const email = url.searchParams.get('email')
    const desktop = url.searchParams.get('desktop') === 'true'

    if (id) {
      if (email === 'true') {
        this.createPDFSendMail(id)
        console.log('email sent')
        window.close()
        return
      }

      window.document.title = 'Proposta_Aldo_Solar_' + id + '.pdf'
      this.getProject(id, desktop)
    }
  },
  watch: {
    'selectedProduct.PRD_DESCR1': function () {
      this.createBaseSimulacao()
    },
    loader: function () {
      setTimeout(() => {
        window.focus()
        if (!this.desktop) {
          window.print()
          window.close()
        } else {
          // Essa função vai ser chamada dentro do 2020.
          // Se o valor do parâmetro for apenas 'print', a tela vai abrir e logo depois,
          // aparecerá o preview da impressão, mas a tela não será fechada.
          // Se o valor do parâmetro for 'print&close', a tela vai abrir e logo depois,
          // aparecerá o preview da impressão e quando o preview for fechado, a tela também será fechada.
          // eslint-disable-next-line no-undef
          cefSharpAction('print')
        }
      }, 500)
    },
  },
  filters: {
    formatDate(value) {
      if (value) {
        const date = new Date(value)
        const day = date.getDate().toString().padStart(2, '0')
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const year = date.getFullYear()
        return `${day}/${month}/${year}`
      }
    },
  },
  methods: {
    ...mapActions(['loadProject', 'calculateProject', 'setComponents', 'setGeneratorImage', 'setpotenciaGerador']),
    toMoeda(value, decimals = 2) {
      if (isNaN(Number(value))) return value

      if (!value && value !== 0) {
        return ''
      }

      const val = (value / 1).toFixed(decimals).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    getGeneratorImage(imgsrc) {
      return '/assets/images/calculadora-solar/' + imgsrc
    },
    createBaseSimulacao() {
      //<h5>#IMPORTANTE#***SIMULAÇÃO*** baseada no índice de incidência de irradiação Solar da regiões do Brasil por m² #IMPORTANTE#</h5>\r\n<img src=https://download.aldo.com.br/energy/tabela-1-13.jpg border=0>\r\n\r\n<h5>#MATERIAPRIMA#</h5>

      this.textoBaseSimulacao = ''
      this.imagemBaseSimulacao = ''

      let desc =
        this.selectedProduct.PRD_DESCR1 +
        this.selectedProduct.PRD_DESCR2 +
        this.selectedProduct.PRD_DESCR3 +
        this.selectedProduct.PRD_DESCR4 +
        this.selectedProduct.PRD_DESCR5 +
        this.selectedProduct.PRD_DESCR5

      let descLen = desc.length
      let indexSimulacao = desc.indexOf('***SIMULAÇÃO***')

      if (indexSimulacao < 0) return ''

      desc = desc.substring(indexSimulacao, descLen)
      descLen = desc.length

      let indexMATERIAPRIMA = desc.indexOf('#MATERIAPRIMA#')
      if (indexMATERIAPRIMA < 0) return ''

      desc = desc.substring(0, indexMATERIAPRIMA)
      desc = desc.replace(/\\n/g, ' ')
      desc = desc.replace(/\\r/g, ' ')
      desc = desc.replace(/<h5>/g, '')
      desc = desc.replace(/<\/h5>/g, '').trim()

      let descVet = desc.split('#IMPORTANTE#')

      let img = descVet[1].substring(descVet[1].indexOf('=') + 1, descVet[1].length)
      img = img.substring(0, img.indexOf(' '))
      this.textoBaseSimulacao = descVet[0]
      this.imagemBaseSimulacao = img
    },

    createPDFSendMail(keyProject) {
      const xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          // swal({
          //     title: "Email encaminhado com sucesso",
          //     icon: "success"
          // })
        }
      }
      xhr.open('POST', this.$apiUrl + 'CalculadoraSolar.svc/sendMailProposta')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(
        JSON.stringify({
          codProjeto: keyProject,
        })
      )
    },
    async getProject(id, desktop = false) {
      await this.loadProject({id, desktop})
      await this.calculateProject()
      await this.setComponents(this.projeto.produto)
      await this.setGeneratorImage(this.projeto.produto)
      await this.setpotenciaGerador(this.projeto.produto)

      this.desktop = desktop

      setTimeout(() => {
        this.loader = false
      }, 500)
    },
  },
  computed: {
    ...mapGetters([
      'descricaoSimplificada',
      'caracteristicasBasicas',
      'selectedProduct',
      'components',
      'parcelas',
      'generatorImage',
      'potenciaGerador',
    ]),
    projeto: {
      get: function () {
        return this.$store.getters.projeto
      },
      set: function (newValue) {
        this.$store.commit('setProjeto', newValue)
      },
    },
    temRevenda() {
      try {
        return (
          this.projeto != undefined &&
          this.projeto.contatoRevenda != undefined &&
          this.projeto.contatoRevenda.nome != undefined &&
          this.projeto.contatoRevenda.nome != ''
        )
      } catch {
        return false
      }
    },
    temBaseSimulacao() {
      try {
        return this.imagemBaseSimulacao != undefined && this.imagemBaseSimulacao != ''
      } catch {
        return false
      }
    },
    contaTotal() {
      let valor = 0
      try {
        for (let index = 0; index < this.projeto.contas.length; index++) {
          const element = this.projeto.contas[index]
          valor += element.valor.toString().replace(/\./g, '').replace(/,/g, '.').replace(/R\$/g, '').trim() * 1
        }
        return valor
      } catch (error) {
        return 0
      }
    },

    consumoTotal() {
      let valor = 0
      try {
        for (let index = 0; index < this.projeto.contas.length; index++) {
          const element = this.projeto.contas[index]
          valor += element.consumoMensal.toString().replace(/\./g, '').replace(/,/g, '.').replace(/R\$/g, '').trim() * 1
        }
        return valor
      } catch (error) {
        return 0
      }
    },

    tarifa() {
      let valor = 0
      try {
        if (this.projeto.contas.length == 1)
          return this.projeto.contas[0].consumoKwh.toString().replace(/\./g, '').replace(/,/g, '.').replace(/R\$/g, '').trim() * 1

        return this.tarifaMedia
      } catch (error) {
        return 0
      }
    },

    tarifaMedia() {
      try {
        if (this.consumoTotal == 0) return 0
        return (this.contaTotal / this.consumoTotal).toFixed(2)
      } catch (error) {
        return 0
      }
    },

    economiaAnual() {
      try {
        return this.contaTotal * 12
      } catch {
        return 0
      }
    },
    retornoInvestimento() {
      try {
        return Math.round(this.investimentoTotal / this.contaTotal / 12)
      } catch {
        return 0
      }
    },
    producaoAnual() {
      try {
        return this.producaoMensal * 12
      } catch {
        return 0
      }
    },
    producaoMensal() {
      try {
        return parseFloat(this.potenciaGerador).toFixed(2) * 4.4 * 30
      } catch {
        return 0
      }
    },
    temQtdeParcela() {
      try {
        return this.projeto.modoPagamento != 0
      } catch {
        return false
      }
    },
    economia25Anos() {
      try {
        return this.economiaAnual * 25 - this.investimentoTotal
      } catch {
        return '-'
      }
    },
    investimentoTotal() {
      try {
        let qtde = 1
        let value = this.projeto.valorEUP.replace(/\./g, '').replace(/,/g, '.').replace(/R\$/g, '').trim() * 1

        if (this.temQtdeParcela) {
          qtde = this.projeto.cliente.parcelaSelecionada.quantidade * 1
          value = this.projeto.cliente.parcelaSelecionada.valor
        }

        //console.log(
        //    this.projeto.valorEUP +
        //    " - " +
        //    qtde.toString() +
        //    "x " +
        //    "valor ...." +
        //    value.toString()
        //);

        return value * qtde
      } catch {
        return 0
      }
    },
    getImagemProduto() {
      try {
        return this.selectedProduct.Imagens[0].ArqUrlHires
      } catch (error) {
        return ''
      }
    },
  },
  data() {
    return {
      opcaoPagamento2: 1,
      textoBaseSimulacao: '',
      imagemBaseSimulacao: '',
      modoPagamentos: ['À vista', 'Financiamento Sol Agora', 'Cartão de crédito'],
      solAgoraLogo: require('./../icons/sol_agora-logo.png'),
      mastercardLogo: require('./../../../../public/assets/images/logo-bandeiras/Master.png'),
      visaLogo: require('./../../../../public/assets/images/logo-bandeiras/Visa.png'),
      aldoSolarLogo: require('./../../../../public/assets/images/calculadora-solar/logo-aldo-solar.svg'),
      arvore: require('./../../../../public/assets/images/calculadora-solar/arvore.png'),
      carro: require('./../../../../public/assets/images/calculadora-solar/carro.png'),
      co2: require('./../../../../public/assets/images/calculadora-solar/co2.png'),
      thunderImage: require('./../icons/thunder.svg'),
      areaImage: require('./../icons/area.svg'),
      weightImage: require('./../icons/weight.svg'),
      checkImage: require('./../icons/check-icon.svg'),
      userImage: require('./../icons/user.svg'),
      suitcaseImage: require('./../icons/suitcase.svg'),
      infoImage: require('./../icons/info.svg'),

      rede: require('./../icons/rede.png'),
      header: require('./../icons/header.png'),
      footer: require('./../icons/footer.png'),
      garantia: require('./../template/garantia.png'),
      loader: true,
      desktop: false,

      // barStyles: {
      //   width: '700px',
      //   maxWidth: '700px',
      //   height: '370px',
      //   maxHeight: '370px',
      //   position: 'relative',
      //   display: 'inline-block',
      // },

      // horizontalBarStyles: {
      //   width: '700px',
      //   maxWidth: '700px',
      //   height: '350px',
      //   maxHeight: '350px',
      //   position: 'relative',
      //   display: 'inline-block',
      // },

      // headers: [
      //   { text: 'Codigo', align: 'left', value: 'codigo'},
      //   { text: 'Descrição', value: 'description' },
      //   { text: 'Qtd', value: 'qtd' },
      // ],
    }
  },
}
</script>
